// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__T3N9f","eyebrow":"styles_eyebrow__dCiX5","headline":"styles_headline__5AHF2","detail":"styles_detail__nELZf"};